export default "__VITE_ASSET__DW9iRJCz__"